import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { hasMarketingConsent, onConsentChange, trackPixel, trackGA } from "@/lib/consent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OAIQ_PIXEL_ID = "A7JpzMd9WS6Zo2vwCV8cem";

const initOaiq = () => {
  if (window.oaiq) return;
  /* eslint-disable */
  !function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");
  /* eslint-enable */
  window.oaiq("init", { pixelId: OAIQ_PIXEL_ID, debug: true });
};

const initPixel = (id) => {
  if (window.fbq) {
    window.fbq("track", "PageView");
    return;
  }
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
};

const initGA4 = (id) => {
  if (window.__ga4) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id);
  window.__ga4 = id;
};

export const MetaPixel = () => {
  const location = useLocation();
  const ids = useRef({ pixel: null, ga4: null });
  const ready = useRef(false);

  useEffect(() => {
    let active = true;
    const start = () => {
      if (ready.current || !hasMarketingConsent()) return;
      initOaiq();
      if (ids.current.pixel) initPixel(ids.current.pixel);
      if (ids.current.ga4) initGA4(ids.current.ga4);
      if (ids.current.pixel || ids.current.ga4) ready.current = true;
    };
    axios
      .get(`${API}/config/public`)
      .then(({ data }) => {
        if (!active || !data) return;
        ids.current = { pixel: data.meta_pixel_id || null, ga4: data.ga4_measurement_id || null };
        start();
      })
      .catch(() => {});
    const unsub = onConsentChange(({ marketing }) => {
      if (marketing) start();
    });
    return () => {
      active = false;
      unsub();
    };
  }, []);

  useEffect(() => {
    if (!ready.current) return;
    if (window.fbq) window.fbq("track", "PageView");
    if (window.gtag && ids.current.ga4) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (!link) return;
      const num = link.getAttribute("href").replace("tel:", "");
      trackPixel("Contact", { content_name: "Phone", phone: num });
      trackGA("contact", { method: "phone", phone_number: num });
      if (hasMarketingConsent()) axios.post(`${API}/events/phone`).catch(() => {});
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
};
